import { makeStyles } from "@material-ui/core/styles";

export function useInfoStyles() {
  const useStyles = makeStyles((theme) => ({
    head: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      padding: theme.spacing(2),
    },
    content: {
      padding: theme.spacing(2),
    },
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      flex: 1,
      gap: theme.spacing(2),
    },
    header: {
      display: "flex",
      gap: theme.spacing(2),
      alignItems: "center",
    },
    title: {
      fontSize: theme.typography.pxToRem(24),
      fontWeight: 400,
      color: theme.palette.text.primary,
      textTransform: "capitalize",
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 400,
      marginBottom: theme.spacing(1),
      color: "#333",
    },
    infosContainer: {
      display: "flex",
      gap: theme.spacing(3),
      color: theme.palette.text.secondary,
    },
    infoContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: theme.spacing(1),
    },
    icons: {
      fontSize: theme.typography.pxToRem(20),
    },
    infoContainerText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 400,
    },
    headerButtonGroup: {
      gap: theme.spacing(1),
      display: "flex",
      justifyContent: "end",
      flex: 1,
    },
    localInfoContainer: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
      alignItems: "flex-start",
    },
    localInfoTitle: {
      color: "#706E7A",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
    },
    localInfoText: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 400,
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
